import { useSnapshot } from "valtio";
import { WidthSimpleButton } from "./WidthSimpleButton";
import { selfAssemblyInputState } from "shared/store/selfAssembly/selfAssemblyInputs";
import { kaderdeurSelectableHeights } from "../../../../app/providers/DoorOptionsProvider";

type KaderdeurSelfMontageHeightType = {
  setHeight: (width: number) => void;
  selectedHeight: number;
};

export const KaderdeurSelfMontageHeight = ({
  setHeight,
  selectedHeight,
}: KaderdeurSelfMontageHeightType) => {
  const heightInputFieldSnapshot = useSnapshot(selfAssemblyInputState);
  return (
    <div
      data-testid="width-opdekdeur-buttons"
      className="gg-mt-0.5 gg-grid gg-grid-cols-3 gg-gap-x-5 gg-gap-y-4"
    >
      {kaderdeurSelectableHeights.map((height) => (
        <WidthSimpleButton
          key={height}
          onClick={() => setHeight(height)}
          isActive={
            selectedHeight === height && !!heightInputFieldSnapshot.heightInput
          }
        >
          {height}
        </WidthSimpleButton>
      ))}
    </div>
  );
};
